// extracted by mini-css-extract-plugin
export default {"table_wrapper":"ConstructionControlProjectsTable_table_wrapper__mIIuY","table":"ConstructionControlProjectsTable_table__DpyQy"};